<template>
    <group-details :groupId="props.groupId">
        <campaign-list :groupId="props.groupId" readOnly withoutOverview embedded></campaign-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import CampaignList from '~/components/campaigns/list/CampaignList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: false,
    },
});

</script>
